import { Formik, Form } from 'formik';
import React, { useState, useEffect } from 'react';
import FormikControl from '../../../hoc/formikComponents/FormikControl'
import { useMutation, useQuery } from 'react-query'
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import { useHistory, useParams } from 'react-router';
import * as Yup from 'yup'
import Select from 'react-select';
import { APIURL } from '../../../hoc/AxiosSetting/axios';
import axios from 'axios';


function AuditTeamProposal() {
    const history = useHistory();
    const [leadauditorList, setLeadauditorList] = useState([{
            label: "",
            value: ""
    }])
    const [assitAuditorList, setassitAuditorList] = useState([{
            label: "",
            value: ""
    }])
    const [technicalExpertList,setTechnicalExpertList] = useState([{
            label:"",
            value:""
    }])
    const [initialValues, setInitialValues] = useState({
        id: "",
        orgCode: 0,
        address: "",
        total: "",
        shifts: "",
        nosites: "",
        effectiveNoEmpToBeAudited: "",
        justificationEffNoEmpConsideration: "",
        contactPersonName: "",
        typeofaudit: "Stage 1",
        dateofaudit: new Date(),
        auditdate1: new Date(),
        auditdate2: new Date(),
        proposedscope: "",
        nacecode: "",
        riskLevel: "",
        offsite: "",
        onsite: "",
        teamleader: "",
        teamleaderName: "",
        auditorOne: "",
        auditorOneName: "",
        auditorTwo: "",
        auditorTwoName: "",
        technicalexpert: "",
        signanddate1: "",
        signanddate2: "",
        proposedby: "",
        approvedby: "",
        approvedname: "",
        proposedname: "",
        proposedsign: "",
        approvedsign: "",
        mandaysPlannedstagetwo: "",
        mandaysPlanned: "",
        accpetConstionsStatus: "",
        approvedByRole: "",
        approvedByName: "",
        approvedByCode: "",

    })
    const [typeOfCertification, setdatashow] = useState(false);
    const onSubmit = (values, { setSubmitting, resetForm }) => {
        console.log("values", values)
        mutation.mutate(values)
    }
    const validationSchema = Yup.object({
        shifts                  : Yup.string().required("Required").matches(/^[0-9]+$/, "Must be only digits"),
        offsite                 : Yup.string().required("Required").matches(/^[0-9]+$/, "Must be only digits"),
        onsite                  : Yup.string().required("Required").matches(/^[0-9]+$/, "Must be only digits"),
        dateofaudit             : Yup.string().required("Required"),
        auditdate2              : Yup.string().required('Required'),
        auditdate1             : Yup.string().required('Required'),
    })
    const mutation = useMutation((params) => Fetcher('patch', '/api/rfq/patch/auditteam', params), {
        onSuccess(data) {

            if (data.data.errorCode === 0) {
                ToastInstance('Success', 'Audit Team Data Added')
                history.push("/" + localStorage.getItem("role") + '/viewauditteamproposal/' + data.data.response.orgCode);
            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const mutationgetCompanyDetails = useMutation((params) => Fetcher('get', '/api/rfq/get/orgdetails/' + params, {}), {
        onSuccess(data) {

            if (data.data.errorCode === 0) {
                var tempInitialValues = data.data.response;
                console.log("tempInitialValues", tempInitialValues)
                tempInitialValues.mandaysPlanned = data.data.response.mandaysPlanned || "";
                tempInitialValues.dateofaudit = Date.parse(data.data.response.dateofaudit) || null;
                tempInitialValues.auditdate1 = Date.parse(data.data.response.auditdate1) || null;
                tempInitialValues.auditdate2 = Date.parse(data.data.response.auditdate2) || null;

                tempInitialValues.stageOneAudit = data.data.response.stageOneAudit || "";
                tempInitialValues.stageTwoAudit = data.data.response.stageTwoAudit || "";
                tempInitialValues.riskLevel = data.data.response.riskLevel || "";
                tempInitialValues.contactPersonName = data.data.response.contactPersonName || "";
                tempInitialValues.typeofaudit = data.data.response.typeofaudit || "Stage 1";
                tempInitialValues.proposedscope = data.data.response.scope || "";
                tempInitialValues.nacecode = data.data.response.nabcbcode || "";
                tempInitialValues.offsite = data.data.response.offsite || "";
                tempInitialValues.onsite = data.data.response.onsite || "";
                tempInitialValues.teamleader = data.data.response.teamleader || "";
                tempInitialValues.teamleaderName = data.data.response.teamleaderName || "";
                tempInitialValues.auditorOne = data.data.response.auditorOne || "";
                tempInitialValues.auditorTwo = data.data.response.auditorTwo || "";

                tempInitialValues.technicalexpert = data.data.response.technicalexpert || "";
                tempInitialValues.approvedby = data.data.response.approvedby || "";
                tempInitialValues.proposedby = data.data.response.proposedbyName || "";
                tempInitialValues.approvedname = data.data.response.approvedname || "";
                tempInitialValues.proposedname = data.data.response.proposedbyName || "";
                tempInitialValues.proposedsign = data.data.response.proposedsign || "";
                tempInitialValues.approvedsign = data.data.response.approvedsign || "";
                tempInitialValues.total = data.data.response.total || "";
                tempInitialValues.accpetConstionsStatus = data.data.response.accpetConstionsStatus || ""
                tempInitialValues.nosites = parseInt(data.data.response.noOfFixedLoc) + parseInt(data.data.response.noOfTempLoc) || ""
                setInitialValues(tempInitialValues)
                if (tempInitialValues.nacecode && tempInitialValues.nacecode !== "") {
                    mutationLeadAudiorDetails.mutate(tempInitialValues.nacecode)
                }
                if (tempInitialValues.nacecode && tempInitialValues.nacecode !== "") {
                    mutationAssisAuditorDetails.mutate(tempInitialValues.nacecode)
                }
                if (tempInitialValues.nacecode && tempInitialValues.nacecode !== "") {
                    mutationTechnicalExpertDetails.mutate(tempInitialValues.nacecode)
                }

               

            } else {
                var msg = 'Company - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Get Company Details' + error)
        }
    })
    const mutationAssisAuditorDetails = useMutation((params) => Fetcher('get', '/api/profile/get/keyvalueforAssistAuditorCommonNacecode/' + params, {}), {
        onSuccess(data) {

            if (data.data.errorCode === 0) {
                console.log("List of ast Auditor", data.data.response)
                setassitAuditorList(data.data.response)
                
            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const mutationLeadAudiorDetails = useMutation((params) => Fetcher('get', '/api/profile/get/keyvalueforleadauditorsCommonNacecode/' + params, {}), {
        onSuccess(data) {
            console.log("Laead Auditor List", data)
            if (data.data.errorCode === 0) {
                console.log("List of Auditor", data.data.response)
                setLeadauditorList(data.data.response)
            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const mutationTechnicalExpertDetails = useMutation((params) => Fetcher('get', '/api/technicalexpert/get/labelvalueTechnicalExpertCommonNacecode/' + params, {}), {
        onSuccess(data) {
            console.log("data expert",data)
            
            if (data.data.errorCode === 0) {
                console.log("List of Technical Expert",data.data.response)
                setTechnicalExpertList(data.data.response)
            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const { orgcode } = useParams()
    // const { data: Rfqdata, isLoading } = useQuery(
    //     'listrfq',
    //     () => Fetcher('get', '/api/rfq/get/orgdetails/' + orgcode, {}))
    const { data: orgList, isLoading: companyListLoading } = useQuery(
        'auditteampropsal',
        () => Fetcher('get', '/api/clientaccess/get/listofcompaniesauditteamproposaldata/' + localStorage.getItem("userCode"), {}))
    
    const options = [
        { key: 'I hearby Accept all condtions ', value: 'I hearby Accept all condtions' },
    ]

    // useEffect(() => {
    //     if (Rfqdata && initialValues.orgCode === 0) {
    //         var tempData = Rfqdata.data.response
    //         tempData.dateofaudit = Date.parse(tempData.dateofaudit);
    //         tempData.auditdate1 = Date.parse(tempData.auditdate1);
    //         tempData.auditdate2 = Date.parse(tempData.auditdate2);
    //         setInitialValues(tempData)
    //         if (tempData.nabcbcode && tempData.nabcbcode !== "") {
    //             mutationLeadAudiorDetails.mutate(tempData.nabcbcode)
    //         }
    //         if (tempData.nabcbcode && tempData.nabcbcode !== "") {
    //             mutationAssisAuditorDetails.mutate(tempData.nabcbcode)
    //         }
    //         if (tempData.nacecode && tempData.nacecode !== "") {
    //             mutationTechnicalExpertDetails.mutate(tempData.nacecode)
    //         }

    //     }
    // }, [orgcode && !isLoading && initialValues.orgCode === 0])


    const getUrl = () =>{
        const api= APIURL + '/api/rfq/get/orgdetails/' +orgcode
        axios.get(api , { headers: {"Authorization" : 'Bearer ' + localStorage.getItem("token")} })
        .then(Rfqdata=>{
            if (Rfqdata && initialValues.orgCode === 0 && Rfqdata.data.response.masteragreementStatus === true) {
                var tempData = Rfqdata.data.response
                tempData.dateofaudit = Date.parse(tempData.dateofaudit);
                tempData.auditdate1 = Date.parse(tempData.auditdate1);
                tempData.auditdate2 = Date.parse(tempData.auditdate2);
                setInitialValues(tempData)
                if (tempData.nabcbcode && tempData.nabcbcode !== "") {
                    mutationLeadAudiorDetails.mutate(tempData.nabcbcode)
                }
                if (tempData.nabcbcode && tempData.nabcbcode !== "") {
                    mutationAssisAuditorDetails.mutate(tempData.nabcbcode)
                }
                if (tempData.nacecode && tempData.nacecode !== "") {
                    mutationTechnicalExpertDetails.mutate(tempData.nacecode)
                }

            }
        })
        .catch(err=>{
            var string= JSON.stringify(err).split("/")[0]
            const regex = /401/g;
            const found = string.match(regex);
            
            console.log("found",found);
            if(found !== null){
                console.log(err)
                window.location.href = "/signin"
            }
        })
    }
   
    useEffect(() => {
        if(orgcode!== undefined){
            getUrl()
        }
       
    }, [orgcode!== undefined])


    if (companyListLoading) return <h1>Loading</h1>
    if (orgcode && initialValues.orgCode === 0){
       
        window.location.href = "/signin"
        return <h1>Loading Data</h1>
       
     }
    return (
        <div>
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}

            >
                {formik => <Form>
                    <div className="content-wrapper">
                        <section className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-sm-12">

                                                    <div className="formOuterDiv">
                                                   
                                                        <div className="form1RowDiv">
                                                        <label className="formSingleElementLabel ">Client Name <span className="required-field"> *</span></label>
                                                            <FormikControl control='selectNACECode'  type='text' options={orgList.data.response} name='orgCode' onChange={e => { mutationgetCompanyDetails.mutate(e.value); }} />
                                                        </div>

                                                        <div className="form1RowDiv mt-4">
                                                            <FormikControl control='textarea' type='text' label='Address' name='address' disabled={true} />
                                                        </div>

                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type='text' label='Effective Number of Employees to be Audited' name='effectiveNoEmpToBeAudited'style={{textAlign:"right"}} disabled={true} />
                                                            <FormikControl control='input' type="text" label='No. of Sites / Temp. sites To be Audited' name='nosites' style={{textAlign:"right"}} disabled={true} />
                                                        </div>

                                                       

                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type='text' label='Contact Person with Designation Contact Number' name='contactPersonName' disabled={true} />
                                                        </div>

                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type='text' label='No. of Employees' name='total' style={{textAlign:"right"}} disabled={true} />
                                                            <FormikControl control='input' type='text' label='Shifts( Ist/ IInd/ IIIrd) *'style={{textAlign:"right"}} name='shifts' />
                                                        </div>


                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type='text' label='Type Of Audit ' name='typeofaudit' disabled={true}/>
                                                            <FormikControl control='date' type='text' label='Date Of Audit *' name='dateofaudit' dateFormat="dd-MM-yyyy" />
                                                        </div>


                                                        <div className="hrstyle headingcolor">
                                                            <h5>Audit Mandays</h5>
                                                        </div>


                                                        <div className="form2RowDiv">
                                                            {/* <FormikControl control='input' type='text' label='Stage 1' name='stageOneAudit' /> */}
                                                            <FormikControl control='input' type='text' label=' Stage 1 Mandays *' name='stageOneAudit' style={{textAlign:"right"}} />
                                                            <FormikControl control='date' type='text' label=' Stage 1 Audit Date *' name='auditdate1' dateFormat="dd-MM-yyyy"  />
                                                        </div>

                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type='text' label=' Stage 2 Mandays *' name='stageTwoAudit' style={{textAlign:"right"}} />
                                                            <FormikControl control='date' type='text' label='  Stage 2 Audit Date *' name='auditdate2' dateFormat="dd-MM-yyyy" />
                                                        </div>

                                                        <hr />

                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type='text' label='Proposed Scope *' name='proposedscope' disabled={true}/>
                                                        </div>

                                                        <div className="form1RowDiv">
                                                            <FormikControl control='input' type='text' label='Risk Level' name='riskLevel' disabled={true} />
                                                        </div>

                                                        <div className="hrstyle headingcolor">
                                                            <h5>No. of Man days for Audit</h5>
                                                        </div>

                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type='text' label='Offsite *' name='offsite' style={{textAlign:"right"}} />
                                                            <FormikControl control='input' type='text' label='Onsite *' name='onsite' style={{textAlign:"right"}}/>
                                                        </div>

                                                        <div className="hrstyle headingcolor">
                                                            <h5>Audit Team</h5>
                                                        </div>
                                                        
                                                        <div className="form2RowDiv">
                                                            <FormikControl control="selectNACECode" name="teamleader" label="Team Leader/ Lead Auditor *" options={leadauditorList}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(`teamleader`,parseInt(e.value))
                                                                    formik.setFieldValue(`teamleaderName`, e.label)
                                                                }}
                                                            />

                                                            <FormikControl control='selectNACECode'  label='Technical Expert'  options={technicalExpertList}   name='technicalexpert'
                                                                     onChange={(e) => {
                                                                            
                                                                        formik.setFieldValue(`technicalexpert`, e.value)
                                                                        formik.setFieldValue(`technicalExpertName`, e.label)
                                                                    }}
                                                                       
                                                                    values={(technicalExpertList).find(i => i.value === `technicalexpert`)} />
                                                           
                                                        </div>

                                                        <div className="form2RowDiv">
                                                            <FormikControl control="selectNACECode" name="auditorOne" label='Auditor One' options={assitAuditorList}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(`auditorOne`, parseInt(e.value))
                                                                    formik.setFieldValue(`auditorOneName`, e.label)
                                                                }}
                                                            />

                                                            <FormikControl control="selectNACECode" name="auditorTwo" label='Auditor Two' options={assitAuditorList}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(`auditorTwo`, e.value)
                                                                    formik.setFieldValue(`auditorTwoName`, e.label)
                                                                }}
                                                            />

                                                        </div>

                                                        <div className="hrstyle headingcolor" >
                                                            <h5 >Innovative Quality Certifications Pvt. Ltd.</h5>
                                                        </div>
                                                        {
                                                            localStorage.getItem("userRole") === "Manager" || localStorage.getItem("userRole") === "Admin" ?
                                                                <div className="row mr-5">
                                                                    <FormikControl  control='checkbox' name='accpetConstionsStatus' options={options}
                                                                        onChange={
                                                                            (e) => {
                                                                                formik.setFieldValue(`accpetConstionsStatus`, e.currentTarget.value)
                                                                                formik.setFieldValue(`approvedname`, localStorage.getItem("fullName"))
                                                                                formik.setFieldValue(`approvedByRole`, localStorage.getItem("userRole"))
                                                                                formik.setFieldValue(`approvedByCode`, localStorage.getItem("userCode"))
                                                                            }
                                                                        }
                                                                    />
                                                                </div>
                                                                : ""
                                                        }
                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type='text' label='Proposed By ' name='proposedname' disabled={true} />
                                                            <FormikControl control='input' type='text' label='Approved By ' name='approvedname'  />
                                                        </div>
                                   
                                                        {/* <div>
                                                            <div className="form1RowDiv">
                                                                <FormikControl control='input' type='text' label='Justification for Effective Number of Employees Consideration' name='justificationEffNoEmpConsideration' disabled={true} />
                                                            </div>
                                                            <div className="form1RowDiv">
                                                            <FormikControl control='input' type='text' label='NACE Code of Client Activity' name='nabcbcodeName' disabled={true} />
                                                            </div>
                                                        </div> */}

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>

                    <div className="card-footer">
                        <div className="row">
                            <div className="col-sm-10"></div>
                            <div className="col-sm-2">
                                <button type="submit" className="btn btn-primary float-right" disabled={!formik.isValid}>Submit</button>
                            </div>

                        </div>
                    </div>
                </Form>
                }
            </Formik>
        </div>
    )
}

export default AuditTeamProposal
